function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 24 24",
    width: 54,
    height: 54,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlnsDefault: "http://www.w3.org/2000/svg",
    id: "qrcode",
    d: "M8.67,15.33H7.34v1.33h1.33V15.33L8.67,15.33z M8.67,7.33H7.34v1.34h1.33V7.34l0,0V7.33z M15.33,7.33v1.34h1.33  V7.34h-1.33V7.33z M6,14h4v4H6V14z M6,6h4v4H6V6z M14,6h4v4h-4V6z M4.67,12.67v6.66h6.66v-6.66H4.67z M15.33,18v1.33h1.33V18H15.33z   M18,18v1.33h1.33V18H18z M19.33,12.67H18V14h-1.34v-1.33h-4v6.66H14v-4h1.33v1.33h4v-4l0,0V12.67z M4.67,4.67v6.66h6.66V4.67H4.67z   M12.67,4.67v6.66h6.66V4.67H12.67z",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    vectorEffect: "non-scaling-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/qrIcon.62022fd9c8c8f3320e979dba14dd83ff.svg";
export { ForwardRef as ReactComponent };